<template>
  <div class="discussionBox">
    <ul>
      <li
        v-for="(item, index) in discussionList"
        :key="index"
        @click="opation('dynamicDetail', item)"
      >
        <div class="top">
          <div class="info">
            <img
              :src="item.customerHeaderimg"
              alt
              @click.stop="opation('userPage', item)"
            />
            <div>
              <p class="name">{{ item.customerName }}</p>
              <p class="time">
                {{ util.friendlyTime(systemtime, item.createdtimestamp) }}
              </p>
            </div>
          </div>
          <div
            class="more"
            @click.stop="report(item, index)"
            :ref="'report' + index"
          >
            <i></i>
          </div>
        </div>
        <div class="content">
          <p>{{ item.content }}</p>
          <div class="imgBox" v-if="item.sourcetype == 1000">
            <ul>
              <li
                v-for="(item1, index1) in item.sources.slice(0, 3)"
                :key="index1"
                @click.stop="&quot;&quot;;"
              >
                <img :src="item1.sourceurl" :preview="index1" alt />
                <span
                  class="more"
                  v-if="item.sources.length > 3 && index1 == 2"
                  @click="opation('dynamicDetail', item)"
                  >{{ "+" + (item.sources.length - 3) }}</span
                >
              </li>
            </ul>
          </div>
          <div class="videoBox" v-if="item.sourcetype == 1001">
            <!-- <Video
              controls="true"
              poster
              src="https://mvod.iartschool.com/20201010/764438500228464640_mid.m3u8?sign=493f9da9d49cb7f128126b1af60a9dd3&t=601285a4"
            ></Video>-->
            <div
              class="Video"
              :style="{
                background: 'url(' + item.image + ') center  no-repeat',
                backgroundSize: 'cover',
              }"
            >
              <i></i>
            </div>
          </div>
          <div class="courseBox" v-if="item.sourcetype == 1004">
            <div class="img">
              <img :src="item.customerHeaderimg" alt />
            </div>
            <div class="content">
              <div class="info">
                <span class="name">{{ item.course.teachername }}</span>
                <i v-if="item.course.levelcn"></i>
                <span class="desc">{{ item.course.levelcn }}</span>
              </div>
              <div class="title">{{ item.course.name }}</div>
              <div class="detail">
                <div>
                  <span class="price"
                    >¥ {{ util.toFixed(item.course.sellprice, 2) }}</span
                  >
                  <span class="lessoncount"
                    >{{ item.course.lessoncount }}讲</span
                  >
                </div>
                <span class="watchcout"
                  >{{
                    util.showCount(item.course.watchcout, "text")
                  }}人学过</span
                >
              </div>
            </div>
          </div>
          <div class="tag" v-if="item.subjecttitle || item.address">
            <div
              class="topicTag"
              v-if="item.subjecttitle"
              @click.stop="opation('topic', item)"
            >
              <span>
                <i></i>
                <em>{{ item.subjecttitle }}</em>
              </span>
            </div>
            <div
              class="location"
              v-if="item.address"
              @click.stop="opation('location', item)"
            >
              <span>
                <i></i>
                <em>{{ item.address }}</em>
              </span>
            </div>
          </div>
          <div class="opation">
            <span class="like" @click.stop="likeOpt(item, index)">
              <i :class="item.customerlike == 'Y' ? 'likes' : ''"></i>
              <span>{{ util.showCount(item.likescount) }}</span>
            </span>
            <span class="news">
              <i></i>
              <span>{{ util.showCount(item.discusscount) }}</span>
            </span>
          </div>
        </div>
      </li>
    </ul>
    <Report
      :showBox="showBox"
      :reportData="reportData"
      :reportTop="reportTop"
      v-on:reportCallback="reportCallback"
    ></Report>
  </div>
</template>

<script>
// import Video from "@/components/videojs";
import Report from "../../course/components/report";

export default {
  props: ["discussionList", "systemtime", "info","mescroll"],
  data() {
    return {
      showBox: "",
      reportData: "",
    };
  },

  compontents: {
    // Video,
    Report,
  },

  mounted() {},
  methods: {
    reportCallback() {
      this.showBox = "";
      this.reportTop = "";
      this.reportData = "";
    },

    report(item, index) {
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      } else {
        console.log(item, index);
        var reportTop = $(this.$refs["report" + index]).offset().top;
        this.$emit("callBack", {
          type: "report",
          data: { item: item, reportTop: reportTop },
        });
      }
    },

    likeOpt(data, index) {
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      var obj = {
        likestype: 4000,
        referencevalue: data.custfeedid,
      };
      this.$post(
        "iart-api-crm/api/crm/custservice/createCustomerlikes",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var likes = res.data ? res.data.likes : "";
            this.discussionList[index].likescount =likes == 1? this.discussionList[index].likescount + 1: this.discussionList[index].likescount - 1;
            this.discussionList[index].customerlike = likes == 1 ? "Y" : "N";
            this.$emit('callBack',{type:'likes',data:likes})
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },

    opation(type, item) {
      switch (type) {
        case "userPage":
          if (item.customerType == 1000) {
            this.$router.push({
              path: "/h5/community/studentPage",
              query: { customerid: item.customerid },
            });
          } else if (item.customerType == 1001 || item.customerType == 1002) {
            this.$router.push({
              path: "/h5/course/artHome/artHome",
              query: { teacherId: item.customerid },
            });
          }
          break;
        case "topic":
          if (item.subjectid) {
            if (this.$route.path.indexOf("community/topic") != -1) {
              if (this.$route.query.subjectid == item.subjectid) {
                 this.mescroll.scrollTo( 0 );
              } else {
                var url1 = "/#/h5/community/topic?subjectid=" + item.subjectid;
                history.replaceState({ subjectid: item.subjectid }, "", url1);
                _this.$router.go(0);
              }
            } else {
              this.$router.push({
                path: "/h5/community/topic",
                query: { subjectid: item.subjectid },
              });
            }
          }
          break;
        case "dynamicDetail":
          if (item.sourcetype == 1004) {
            this.$router.push({
              path: "/h5/course/courseDetail",
              query: { courseId: item.course.courseid, courseType: 1000 },
            });
          } else {
            this.$router.push({
              path: "/h5/course/artHome/dynamicDetail",
              query: { custfeedId: item.custfeedid },
            });
          }
          break;
        case "location":
          window.location.href =
            "http://api.map.baidu.com/marker?location=" +
            item.locationy +
            "," +
            item.locationx +
            "&content=" +
            item.address +
            "&output=html";
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.discussionBox {
  padding: 0 1px;
  > ul {
    > li {
      margin-top: 16px;
      .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .info {
          display: flex;
          flex-direction: row;
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 8px;
            object-fit: cover;
          }
          > div {
            p:nth-child(1) {
              font-size: 14px;
              font-weight: bold;
              line-height: 20px;
              color: #35363c;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
            p:nth-child(2) {
              font-size: 11px;
              line-height: 20px;
              color: rgba(53, 54, 60, 0.4);
            }
          }
        }
        .more {
          i {
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../../../assets/img/h5/report.png) no-repeat;
            background-size: 24px 24px;
          }
        }
      }
      .content {
        p {
          margin: 8px 0;
          font-size: 13px;
          line-height: 23px;
          letter-spacing: 0.4px;
          color: #35363c;
          vertical-align: middle;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
        .imgBox {
          > ul {
            // width: calc(100% + 2px);
            display: flex;
            flex-direction: row;
            > li {
              float: left;
              width: 110px;
              height: 110px;
              position: relative;
              overflow: hidden;
              > img {
                display: inline-block;
                object-fit: cover;
                width: 110px;
                height: 110px;
                border-radius: 4px;
              }
              > .more {
                position: absolute;
                display: inline-flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                line-height: 25px;
                background: rgba(0, 0, 0, 0.6);
                border-radius: 4px;
                text-align: center;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 8;
                color: #ffffff;
                font-weight: bold;
              }
            }
            li:not(:last-child) {
              margin-right: 4px;
            }
          }
        }
        .videoBox {
          display: inline-block;
          width: 100%;
          height: 193px;
          border-radius: 4px;
          overflow: hidden;
          .Video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: relative;
            i {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -28px;
              margin-left: -28px;
              width: 56px;
              height: 56px;
              background: url(../../../../assets/img/h5/play.png);
              background-size: 56px 56px;
            }
          }
        }
        .courseBox {
          display: flex;
          flex-direction: row;
          .img {
            width: 134px;
            height: 82px;
            border-radius: 3px;
            margin-right: 12px;
            img {
              display: inline-block;
              object-fit: cover;
              width: 134px;
              height: 82px;
              border-radius: 3px;
            }
          }
          > .content {
            flex: 1;
            .info {
              margin-top: 4px;
              padding-bottom: 3px;
              border-bottom: 0.5px solid rgba(45, 45, 45, 0.15);
              span {
                font-size: 12px;
                line-height: 17px;
                font-weight: 300;
                color: #35363c;
              }
              i {
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #c9373d;
                border-radius: 50%;
                margin: 0 6px;
                vertical-align: middle;
              }
            }
            .title {
              font-size: 14px;
              font-weight: bold;
              line-height: 18px;
              color: #35363c;
              margin: 3px 0 13px;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .detail {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;

              > div {
                span {
                  font-size: 11px;
                  padding: 2px 4px;
                  border-radius: 2px;
                }
                .price {
                  color: #ffffff;
                  background: linear-gradient(to right, #dcc288, #cfb67d);
                }
                .lessoncount {
                  color: #ffffff;
                  background: linear-gradient(to right, #c3bcb9, #b8b8b8);
                  margin-left: 6px;
                }
              }
              .watchcout {
                font-size: 11px;
                color: #86878a;
              }
            }
          }
        }
        .tag {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 8px;
          max-width: 100%;
          .topicTag {
            max-width: 137px;
            margin-right: 12px;
            span {
              display: inline-block;
              padding: 4px 8px;
              border-radius: 24px;
              background: #f4f4f7;
              height: 24px;
              display: flex;
              flex-direction: row;
              align-items: center;
              i {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url(../../../../assets/img/h5/tag.png) no-repeat;
                background-size: 16px 16px;
                margin-right: 4px;
                vertical-align: middle;
              }
              em {
                // max-width: 86%;
                font-size: 11px;
                line-height: 16px;
                letter-spacing: 0.34px;
                color: #86878a;
                vertical-align: middle;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
            }
          }
          .location {
            max-width: 40%;
            span {
              display: inline-block;
              padding: 4px 8px;
              border-radius: 24px;
              background: #f4f4f7;
              height: 24px;
              display: flex;
              flex-direction: row;
              align-items: center;
              i {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url(../../../../assets/img/h5/address.png) no-repeat;
                background-size: 16px 16px;
                margin-right: 4px;
                vertical-align: middle;
              }
              em {
                max-width: 86%;
                font-size: 11px;
                line-height: 16px;
                letter-spacing: 0.34px;
                color: #86878a;
                vertical-align: middle;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
            }
          }
        }

        .opation {
          margin: 16px 4px 0 0;
          span {
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            font-size: 11px;
            color: rgba(53, 54, 60, 0.3);
            margin-right: 24px;
            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              vertical-align: middle;
            }
          }
          .like {
            i {
              background: url(../../../../assets/img/h5/like.png) no-repeat;
              background-size: 16px 16px;
              margin-right: 4px;
            }
            i.likes {
              background: url(../../../../assets/img/h5/likes.png) no-repeat;
              background-size: 16px 16px;
            }
          }
          .news {
            i {
              background: url(../../../../assets/img/h5/message.png) no-repeat;
              background-size: 16px 16px;
              margin-right: 4px;
            }
          }
        }
      }
    }
    > li:not(:last-child) {
      border-bottom: 0.5px solid #e0e0e0;
      padding-bottom: 16px;
    }
  }
}
</style>